import { FormikErrors, setIn } from "formik";

type SettingsErrors = FormikErrors<Record<string, unknown>>;

export interface MappedSettingsErrors {
  fieldErrors: SettingsErrors;
  notificationMessage?: string;
}

const minimumFieldSegments = 2;

function fieldPath(path: string) {
  const segments = path.split(".");
  const firstIndex = segments.findIndex((segment) => /^\d+$/.test(segment));
  return (firstIndex === -1 ? segments : segments.slice(0, firstIndex)).join(".");
}

function namesField(path: string) {
  return path.split(".").length >= minimumFieldSegments;
}

export function toFieldErrors(errors: Record<string, string[]>): MappedSettingsErrors {
  const fieldMessages: Record<string, string[]> = {};
  const notificationMessages: string[] = [];

  Object.entries(errors).forEach(([errorPath, messages]) => {
    const path = fieldPath(errorPath);
    if (namesField(path)) {
      fieldMessages[path] = [...(fieldMessages[path] ?? []), ...messages];
    } else {
      notificationMessages.push(...messages);
    }
  });

  const fieldErrors = Object.entries(fieldMessages).reduce<SettingsErrors>(
    (nested, [path, messages]) => setIn(nested, path, messages.join(", ")),
    {},
  );

  return notificationMessages.length === 0
    ? {fieldErrors}
    : {fieldErrors, notificationMessage: notificationMessages.join(", ")};
}
